<template>
  <common-listing
    :dataType="dataType"
    :dataElements="apiResponse"
    @getElements="getElements"
    :selectableColumns="selectableColumns"
    :sortableColumns="sortableColumns"
    defaultSortColumn="Collection"
    :catalogueFields="catalogueFields"
    :arrayFields="arrayFields"
    :enableEdition="false"
  ></common-listing>
</template>

<script>
import CommonListing from '@/components/CommonListing'
import * as datasets from '@/lib/datasets'
import * as api from '@/lib/api'

export default {
  name: 'datasets',
  components: {
    CommonListing,
  },
  data() {
    return {
      dataType: 'Dataset',
      apiResponse: null,
    }
  },
  computed: {
    selectableColumns() {
      return datasets.getPublicColumns()
    },
    // Define sortable columns and map label to field key for API
    catalogueFields() {
      return datasets.getDataMapping()
    },
    // Define sortable columns and map label to field key for API
    sortableColumns() {
      return datasets.sortableColumns()
    },
    arrayFields() {
      return datasets.getArrayFields()
    },
  },
  methods: {
    async getElements(type, searchParams) {
      if (type === 'Dataset') {
        let response = await api.getDatasets(searchParams)
        this.$emit('finishLoading')
        // Create locally in frontend new field id so it is valid for both
        response.results = response.results.map((item) => {
          item.id = item.collection_id
          return item
        })
        this.apiResponse = response
      }
    },
  },
}
</script>

<style></style>
